import styled from 'styled-components';

export const BookedHotelInfoOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    border-radius: 1rem;
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.1);
    background-color: ${props.theme.colors.white.base};
    margin-bottom: ${props.theme.spacing.large.l15};
  `
);
